export default {
  psw: "पासवर्ड",
  topFive: "शीर्ष पाँच",
  confPsw: "पासवर्ड पुष्टि गर्नुहोस",
  newPsw: "नयाँ पासवर्ड",
  email: "इमेल",
  emailId: "इमेल आईडी",
  submit: "पेश गर्नुहोस्",
  cancel: "रद्द गर्नुहोस्",
  dashboard: "ड्यासबोर्ड",
  faqs: "एफएक्यू",
  users: "प्रयोगकर्ताहरू",
  appUser: "एप प्रयोगकर्ता",
  app_users: "एप प्रयोगकर्ताहरू",
  dimitraAdmin: "डिमित्रा एडमिन",
  admin_users: "एडमिन प्रयोगकर्ताहरू",
  search: "खोज",
  searchBy: "खोज {type}",
  autoCondition: "स्वत: अवस्था",
  firstName: "पहिलो नाम",
  lastName: "थर",
  mobile: "मोबाइल",
  mobileNumber: "मोबाइल नम्बर",
  department: "विभाग",
  role: "भूमिका",
  status: "स्थिति",
  permission: "अनुमतिहरू",
  activity_log: "गतिविधि लगहरू",
  profile_auth: "प्रोफाइल प्रमाणीकरण",
  countryCode: "देशको कोड",
  selectDept: "विभाग छान्नुहोस्",
  selectRole: "भूमिका छनौट गर्नुहोस्",
  edit: "एडिट गर्नुहोस्",
  update: "अपडेट गर्नुहोस्",
  delete: "डिलिट गर्नुहोस्",
  view: "हेर्नुहोस्",
  deactivate: "निष्क्रिय पार्नुहोस्",
  activate: "सक्रिय गर्नुहोस्",
  serverError: "केहि गलत भयो। कृपया केहि समय पछि प्रयास गर्नुहोस्।",
  minute: "मिनेट",
  perHour: "प्रति घण्टा",
  day: "दिन",
  enterDescription: "यहाँ आफ्नो विवरण प्रविष्ट गर्नुहोस्",
  enterHere: "यहाँ प्रविष्ट गर्नुहोस्",
  enterMobile: "मोबाइल नम्बर प्रविष्ट गर्नुहोस्",
  phoneRequired: "फोनको आवश्यकता रहेको छ",
  phoneValid: "फोन मान्य हुनुपर्दछ",
  unableToUpdate: "अपडेट गर्न असमर्थ रहेको छ",
  membershipPlans: "सदस्यता योजनाहरू",
  byWeek: "हप्ता अनुसार",
  byMonth: "महिना अनुसार",
  byYear: "वर्ष अनुसार",
  custom: "अनुकूलन",
  name: "नाम",
  regionState: "क्षेत्र/राज्य",
  provinceState: "प्रदेश/राज्य",
  cityTown: "शहर/नगर",
  membershipValidity: "सदस्यता वैधता",
  exportAsCSV: "सीएसभीको रूपमा एक्सपोर्ट गर्नुहोस्",
  filterBy: "निम्न विषयद्वारा फिल्टर गर्नुहोस्",
  comingSoon: "छिट्टै आउदैँछ",
  userRole: "प्रयोगकर्ताको भूमिका",
  additionalInformationRequired: "थप जानकारीको आवश्यकता रहेको छ।",
  back: "पछाडि जानुहोस्।",
  approve: "स्वीकृत गर्नुहोस्",
  reject: "अस्वीकृत गर्नुहोस्",
  username: "प्रयोगकर्ताको नाम",
  phone: "फोन",
  roleAssigned: "भूमिका तोकियो",
  roleRequested: "भूमिका अनुरोध गरिएको छ",
  requestedDate: "अनुरोध गरिएको मिति",
  updateRoleRequest: "भूमिकाको अनुरोध अपडेट गर्नुहोस्",
  message: "सन्देश",
  selectFarmers: "किसानहरू छान्नुहोस्",
  faqSection: {
    createFaq: "एफएक्यू सिर्जना गर्नुहोस्",
    createTopic: "विषय सिर्जना गर्नुहोस्",
    selectTopic: "विषय छनौट गर्नुहोस्",
    faqQuestion: "एफएक्यू प्रश्न",
    faqAnswer: "एफएक्यू उत्तर",
    uploadImgVid: "तस्विर/भिडियो अपलोड गर्नुहोस्",
    disInFaq: "एफएक्यू खण्डमा डिस्प्ले गर्नुहोस्",
    editFaq: "एफएक्यू एडिट गर्नुहोस्",
    topicName: "विषयको नाम",
    parentTopic: "अभिभावकको विषय",
    editTopic: "विषय एडिट गर्नुहोस्",
    createSection: "कृपया पहिले खण्ड सिर्जना गर्नुहोस्",
    createTopicFirst: "Please create topic first",
    questionReq: "एफएक्यू प्रश्न आवश्यक छ",
    answerReq: "एफएक्यू उत्तर आवश्यक छ",
  },
  reports: {
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    farmerName: "किसानको नाम",
    farmerProdChart: "किसानको उत्पादन चार्ट",
    production: "उत्पादन",
    byProduction: "उत्पादनद्वारा",
    byName: "नामद्वारा",
    descending: "घटिरहेको",
    ascending: "बढिरहेको",
    buyingStationProdChart: "स्टेशन उत्पादन चार्ट खरीद",
    buyingStation: "खरिद गर्ने स्टेशन",
    buyingStationName: "स्टेशनको नाम किन्दै",
    dryMilling: "ड्राई मिलिङ",
    dryMillingName: "ड्राई मिलिङ नाम",
    dryMillingProdChart: "ड्राई मिलिङ उत्पादन चार्ट",
    view: "हेर्नुहोस्",
    date: "मिति",
  },
  cacaoTraceability: {
    traceability: "पूर्वपुस्तीकरण",
    cacaoTraceabilityMngmnt: "काकाओ पूर्वपुस्तीकरण प्रबन्धन",
    traceabilityPage: "पूर्वपुस्तीकरण पृष्ठ",
    labelDesigner: "लेबल डिजाइनर",
    additionalInformation: "थप जानकारी",
    info1:
      "तपाईंको उत्पादका अतिरिक्त लोगोहरूको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
    addSlogan: "स्लोगन थप्नुहोस्",
    additionalLogos: "थप लोगोहरू",
    title: "शीर्षक",
    description: "विवरण",
    mapLink: "नक्सा लिंक",
    websiteLink: "वेबसाइट लिंक",
    addMedia: "मिडिया थप्नुहोस्",
    uploadImageVideo: "चित्र/भिडियो अपलोड गर्नुहोस्",
    origin: "मूल",
    info2:
      "तपाईंको उत्पादको मूल देशका बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
    countryImage: "देश चित्र",
    institutionalInfo: "संस्थागत जानकारी",
    info3:
      "तपाईंको कम्पनी/सहकारीका बारेमा जानकारी प्रदान गर्नुहोस्, उपभोक्ताहरूलाई तपाईंको कामका बारेमा बताउनुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
    cooperativeLogo: "सहकारी लोगो",
    traceabilityIntro: "पूर्वपुस्तीकरण परिचय",
    info4:
      "यस खण्डले उपभोक्तालाई कफि उत्पादन र प्रसंस्करणका पूरा इतिहासमा पहुँच प्रदान गर्दछ। तपाईंको कम्पनी/सहकारीको र पूर्वपुस्तीकरणको महत्त्वको बारेमा बयान गर्दछ।",
    addLabel: "लेबल थप्नुहोस्",
    chooseTitle: "शीर्षक छनोट गर्नुहोस्",
    chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट छनोट गर्नुहोस्",
    uploadYourLogo: "तपाईंको लोगो अपलोड गर्नुहोस्",
    info5:
      "सुचना: चित्रको आकार कम्तिमा 1000 x 1000 पिक्सल वर्ग गर्नुपर्छ। तपाईं जस्तो पृष्ठभूमि रंगसँग सिङ्क गर्न Transparent PNG छनोट गर्न सक्दैछ।",
    chooseTemplateColors: "टेम्प्लेट रङ्गहरू छनोट गर्नुहोस्",
    backgroundColor: "पृष्ठभूमि रंग",
    foregroundColor: "मुख्य रंग",
    labelStatus: "लेबल स्थिति",
    inactive: "निष्क्रिय",
    download: "डाउनलोड गर्नुहोस्",
    enterLabelTitle: "लेबल शीर्षक प्रविष्टि गर्नुहोस्",
  },
  setting: {
    profileAuthSetting: "प्रोफाइल प्रमाणीकरण सेटिङहरू",
    logInOutSetting: "लगइन/लगआउट सेटिङहरू",
    autoLogout: "स्वतः लगआउट",
    unsuccessfulLoginAttempt: "असफल लगइन प्रयासहरू",
    unsuccessfulLoginLockPeriod: "असफल लगइन लक-आउट अवधि",
    passCriteriaSetup: "पासवर्ड मापदण्ड सेटअप",
    passLength: "पासवर्डको लम्बाइ",
    noUniquePassRequired: "खास पासवर्डहरूको संख्या आवश्यक छ",
    maxPassAge: "अधिकतम पासवर्ड समय",
    acceptableRangeOfChars: "वर्णहरूको स्वीकार्य दायरा",
    upperCase: "ठूला अक्षर",
    lowerCase: "साना अक्षर",
    numbers: "संख्याहरू",
    specialChars: "विशेष वर्ण",
    uniqueSymbols: "खास प्रतिक",
    loadingData: "डाटा लोड गर्दैछ...",
    currency: "मुद्रा",
    codeActivationTime: "कोड एक्टिभेसन समय",
    changeGlobalSetting: "ग्लोबल सेटिङहरू परिवर्तन गर्नुहोस्",
    globalSetting: "ग्लोबल सेटिङहरू",
    generalSetting: "सामान्य सेटिङहरू",
    hour: "घण्टा",
    days: "दिन",
    minutes: "मिनेट",
    perDay: "प्रति दिन",
    perHour: "प्रति घण्टा",
    customised: "अनुकूलित",

    smallFarm: "सानो फार्म",
    inclusive: "समावेशी",
    from: "देखि",
    to: "सम्म",
    mediumFarm: "मध्यम फार्म",
    largeFarm: "ठूलो फार्म",
    requiredMessage: "यो फिल्ड आवश्यक छ",
    nonNegativeMessage: "यो फिल्ड गैर-नकारात्मक हुनु पर्छ",
    fieldToGreaterThanFrom: "यो फिल्ड 'देखि' फिल्ड भन्दा ठूलो हुनु पर्छ",
    fieldToGreaterThanFromMedium: "यो फिल्ड सानो फार्मको 'सम्म' फिल्ड भन्दा ठूलो हुनु पर्छ",
    fieldToGreaterThanMediumTo: "यो फिल्ड मध्यम फार्मको 'सम्म' फिल्ड भन्दा ठूलो हुनु पर्छ",
  },
  traceability: {
    traceability: "परिपुर्णता",
    coffeeTraceabilityMngmnt: "कफी परिपुर्णता प्रबन्धन",
    traceabilityPage: "परिपुर्णता पृष्ठ",
    labelDesigner: "लेबल डिजाइनर",
    additionalInformation: "थप जानकारी",
    info1:
      "तपाईंको उत्पादको थप लोगोहरूको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
    addSlogan: "स्लोगन थप्नुहोस्",
    sloganTooltip: "तपाईँको उत्पादनमा एउटा नारा थप्नुहोस्। यो जानकारी ट्रेसिबिलिटी पृष्ठमा सार्वजनिक रूपमा उपलब्ध हुनेछ।",
    additionalLogos: "थप लोगोहरू",
    title: "शीर्षक",
    description: "वर्णन",
    mapLink: "नक्शा लिंक",
    websiteLink: "वेबसाइट लिंक",
    addMedia: "मिडिया थप्नुहोस्",
    uploadImageVideo: "तस्वीर/भिडियो अपलोड गर्नुहोस्",
    origin: "मूल",
    info2:
      "तपाईंको उत्पादको मूल देशको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
    countryImage: "देश तस्वीर",
    institutionalInfo: "संस्थागत जानकारी",
    info3:
      "तपाईंको कम्पनी/सहकारीका बारेमा जानकारी प्रदान गर्नुहोस्, उपभोक्तालाई तपाईंले गरेका सम्बन्धित कामका बारेमा भन्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
    cooperativeLogo: "सहकारीको लोगो",
    traceabilityIntro: "परिपुर्णता परिचय",
    info4:
      "यस खण्डले उपभोक्तालाई कफीको पूरा उत्पादन र प्रसंस्करण इतिहासमा पहुँच दिनेछ। तपाईंको कम्पनी/सहकारीमा परिपुर्णताको महत्त्व र विश्वको लागि महत्त्व बयान गर्दछ।",
    addLabel: "लेबल थप्नुहोस्",
    chooseTitle: "शीर्षक छनौट गर्नुहोस्",
    chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट छनौट गर्नुहोस्",
    uploadYourLogo: "तपाईंको लोगो अपलोड गर्नुहोस्",
    info5:
      "सूचना: तस्वीरको आकार कम्तिमा 1000 x 1000 पिक्सेल वर्ग हुनुपर्छ। तपाईं बैकग्राउन्ड रंगको समानुप्रेषण गर्नका लागि पारदर्शी PNG छनौट गर्न सक्दैनुहुनेछ।",
    chooseTemplateColors: "टेम्प्लेट रंग छनौट गर्नुहोस्",
    backgroundColor: "पृष्ठभूमि रङ",
    foregroundColor: "पूर्वभूमि रंग",
    labelStatus: "लेबल स्थिति",
    inactive: "निष्क्रिय",
    download: "डाउनलोड गर्नुहोस्",
    enterLabelTitle: "लेबल शीर्षक प्रविष्ट गर्नुहोस्",
  },
  coffeeData: {
    windBreaker: "हावा छिर्ने विन्ड ब्रेकर रूख",
    horticultureInfo: "बागवानीको रूख",
    shadeTree: "छायाँ आउने रुख",
    coffeeVariety: "कफी विविधता",
    coffeeSpecies: "कफीका प्रजातिहरू",
    updateWindBreaker: "हावा छिर्ने विन्ड ब्रेकर रूखको प्रकार अपडेट गर्नुहोस्।",
    addWindBreaker: "नयाँ पङ्तिमा रोपिएका विन्ड ब्रेकर ट्रीको प्रकार थप्नुहोस्",
    updateHorticultureInfo:
      "बागवानीको जानकारी भएको रूखको प्रकार अपडेट गर्नुहोस्।",
    addHorticultureInfo: "नयाँ बागवानी जानकारी भएको रूखको प्रकार थप्नुहोस्।",
    updateShadeTree: "छाँया आउने रूखको प्रकार अपडेट गर्नुहोस्।",
    addShadeTree: "नयाँ कफीका विविधता भएको रूखको प्रकार थप्नुहोस्।",
    updateCoffeeVariety: "कफीको विविधता भएको रूखको प्रकार अपडेट गर्नुहोस्।",
    addCoffeeVariety: "नयाँ कफीका विविधता भएको रूखको प्रकार थप्नुहोस्।",
    deleteVarietyTitle: "विविधता डिलिट गर्नुहोस्।",
    deleteVarietyMessage: "के तपाईं विविधता डिलिट गर्न निश्चित हुनुहुन्छ?",
    updateCoffeeSpecie: "कफीको प्रजाति अपडेट गर्नुहोस्।",
    deleteSpecieTitle: "प्रजाति डिलिट गर्नुहोस्।",
    deleteSpecieMessage: "के तपाईं प्रजाति डिलिट गर्न चाहनुभएको पक्का हो?",
    addCoffeeSpecie: "नयाँ कफीको प्रजाति थप्नुहोस्।",
    variety: "विविधता",
    selectVariety: "विविधता छनौट गर्नुहोस्।",
    deleteCoffeeRecord: "के तपाईं रेकर्ड डिलिट गर्न निश्चित हुनुहुन्छ?",
    deleteCoffeeData: "कफीको डाटा डिलिट गर्नुहोस्",
    topicRequired: "विषयको नाम आवश्यक रहेको छ।",
    coffeeAddSuccess: "कफीको प्रजाति सफलतापूर्वक थपियो।",
    treeTypeSuccess: "रुखको प्रकार सफलतापूर्वक थपियो।",
    treeTypeUpdateSuccess: "रूखको प्रकार सफलतापूर्वक अपडेट गरियो।",
    coffeeVarietySuccess: "कफीको विविधता सफलतापूर्वक थपियो।",
    coffeeSpecieSuccess: "कफीको प्रजाति सफलतापूर्वक अपडेट गरियो।",
    nameRequired: "नाम आवश्यक रहेको छ।",
    notFound: "कुनै एडमिन कफी डाटा फेला परेन।",
  },
  cacaoData: {
    cacao: "काकाओ",
    cacaoVariety: "काकाओ प्रकार",
    cacaoSpecies: "काकाओ प्रजाति",
    deleteCacaoData: "काकाओ डाटा मेटाउनुहोस्",
  },
  plantation: {
    farmerName: "किसानको नाम",
    phoneNumber: "फोन नम्बर",
    plantationName: "रोपेको बिरुवाको नाम",
    farm: "फार्म",
    location: "स्थान",
    updatePlantationStatus: "बिरुवा रोपेको स्थिति अपडेट गर्नुहोस्।",
    update: "अपडेट गर्नुहोस्",
  },
  dashboardReports: {
    appDataReports: "एप डाटा प्रतिवेदन",
    reports: "प्रतिवेदन",
  },
  activationKey: {
    enterActivationKey: "नयाँ प्रयोगकर्ता दर्ता गर्न कृपया सक्रियकरण कुञ्जी प्रविष्ट गर्नुहोस्",
    activationKeyLimit: "सक्रियकरण कुञ्जी धेरै छोटो छ",
    countryRequired: "देश आवश्यक छ",
    activationKey: "एक्टिभेसन कीहरू",
    appointSalesManager: "बिक्री प्रबन्धक नियुक्त गर्नुहोस्।",
    appointManager: "प्रबन्धक नियुक्त गर्नुहोस्।",
    salesManAppSuccess: "बिक्री प्रबन्धक सफलतापूर्वक नियुक्त गरियो।",
    uploadData: "तोकिएको डाटा सीएसभी अपलोड गर्नुहोस्",
    uploadUserData: "कृपया प्रयोगकर्ता डाटा फाइल अपलोड गर्नुहोस्।",
    downloadCsv: "(संरचना पालना गर्न नमूना .csv फाइल डाउनलोड गर्नुहोस्)",
    downloadSample: "नमूना फाइल डाउनलोड गर्नुहोस्",
    dragDrop: "ड्र्याग गर्नुहोस् र छोड्नुहोस् वा",
    browse: "ब्राउज गर्नुहोस्।",
    yourFile: "तपाईंको फाइल",
    incorectFileType: "गलत फाइलको प्रकार",
    somethingWentWrong: "केहि गलत भयो",
    fileUploadedSuccess: "फाइल सफलतापूर्वक अपलोड गरियो।",
    countRecords: "गणना रेकर्डहरू",
    sendNow: "अहिले पठाउनुहोस्।",
    fileName: "फाइलको नाम",
    assignActKey: "एक्टिभेसन कीहरू तोकिदैँ",
    actKeyAssSucc: "एक्टिभेसन कीहरू सफलतापूर्वक तोकियो।",
    viewActKey: "एक्टिभेसन कीहरू हेर्नुहोस्।",
    actKeyQuota: "एक्टिभेसन कीको कोटा",
    genActKey: "जेनरेट गरिएका एक्टिभेसन कीहरू",
    remActKey: "बाँकी एक्टिभेसन कीहरू",
    penUsed: "बाँकी रहेको र प्रयोग गरिएका कीहरू",
    activationKeyAss: "एक्टिभेसन की तोकिएको छ",
    activationKeyUnass: "एक्टिभेसन की तोकिएको छैन",
    keysAct: "कीहरू एक्टिभेट गरियो",
    uploadedFiles: "अपलोड गरिएका फाइलहरू",
    generateActKey: "एक्टिभेसन कीहरू जेनरेट गर्नुहोस्",
    showData: "डाटा देखाउनुहोस्।",
    noDataFound: "कुनै मिति फेला परेन।",
    pleaseGenKey:
      "कृपया 'एक्टिभेसन कीहरू जेनरेट गर्नुहोस्' बटन प्रयोग गरेर एक्टिभेसन कीहरू जेनरेट गर्नुहोस्।",
    noActKey: "कुनै एक्टिभेसन की अझै जेनरेट भएको छैन।",
    buttonAbv: "माथिको बटन",
    numberOfActKey: "एक्टिभेसन कीहरूको संख्या",
    membershipRole: "सदस्यता भूमिका",
    membershipPlan: "सदस्यता वैधता",
    comments: "टिप्पणीहरू",
    genKeys: "कीहरू जेनरेट गर्नुहोस्",
    keysNum: "कीको नम्बर",
    phoneNumber: "फोन नम्बर",
    keysStatus: "कीको स्थिति",
    ActivationKeysList: "एक्टिभेसन कीहरूको सूची",
    back: "पछाडि जानुहोस्",
    usingActKeys: "'एक्टिभेसन कीहरू जेनरेट गर्नुहोस्' प्रयोग गर्दै",
    pleaseGenActKeyss: "कृपया एक्टिभेसन कीहरू जेनरेट गर्नुहोस्।",
    clearAllFilters: "सबै फिल्टरहरू खाली गर्नुहोस्",
    salesManager: "बिक्री प्रबन्धक",
    clearAll: "सबै खाली गर्नुहोस्",
    generatedBy: "निम्नद्वारा जेनरेट गरिएको",
    numberOfKeys: "कीहरूको संख्या",
    action: "कार्य",
    viewAllUplFiles: "सबै अपलोड गरिएका फाइलहरू हेर्नुहोस्",
    bulkUploadUsers: "बल्क अपलोड प्रयोगकर्ताहरू",
    noActivationKeyFound: "कुनै एक्टिभेसन कीहरू फेला परेनन्।",
    pleaseCreateAdminRole:
      "कृपया माथिको 'एडमिनको भूमिका सिर्जना गर्नुहोस्' बटन",
    btnCreateAdmin: "प्रयोग गरेर एडमिनको भूमिका सिर्जना गर्नुहोस्।",
    donwloadAsCsv: "सीएसभीको रूपमा डाउनलोड गर्नुहोस्।",
    donwloadAsPdf: "पिडिएफको रूपमा डाउनलोड गर्नुहोस्।",
    assignSalesManager: "बिक्री प्रबन्धक नियुक्त गर्नुहोस्।",
    shareViaEmail: "इमेलमार्फत आदान गर्नुहोस्।",
    sendEmail: "इमेल पठाउनुहोस्।",
    emailSend: "इमेल सफलतापूर्वक पठाइयो।",
    donwload: "डाउनलोड गर्नुहोस्।",
    deleteFile: "फाइल डिलिट गर्नुहोस्।",
    invalidFileData: "फाइलमा सक्रियता कुञ्जी डाटा अमान्य छ",
    continue: "जारी राख्नुहोस्",
    description: "विवरण",
    selectWeek: "हप्ता छनौट गर्नुहोस्",
    confirm: "पुष्टि गर्नुहोस्।",
    selectMonth: "महिना छनौट गर्नुहोस्।",
    selectDateRange: "मितिको दायरा छनौट गर्नुहोस्।",
    regionDistrict: "क्षेत्र/जिल्ला",
    address: "ठेगाना",
    familyTribe: "परिवारको जात",
    website: "वेबसाइट",
    deactivated: "डिएक्टिभेट गरियो",
    active: "सक्रिय",
    country: "देश",
    farmer: "किसान",
    commodity: "सामग्री",
    quantity: "मात्रा",
    unit: "एकाइ",
    price: "मूल्य",
    save: "बचत गर्नुहोस्",
    stateIsReq: "राज्य आवश्यक रहेको छ।",
    cityIsReq: "शहर आवश्यक रहेको छ।",
    addressIsReq: "Address is required",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "विस्तारित सदस्यताको वैधता",
    set: "SET",
    adminRole: "एडमिनका भूमिकाहरू",
    typeMsg: "Type your message here",
    errors: {
      cannotBeBlank: "यो क्षेत्र खाली हुन सक्दैन।",
      required: "यो क्षेत्र आवश्यक छ।",
      somethingWentWrong: "केहि गलत भयो। कृपया केहि समय पछि प्रयास गर्नुहोस्।",
    },
    loadingData: "डाटा लोड गर्दैछ...",
    markAsRead: "पढिसकेको भनेर चिन्ह लगाउनुहोस्",
    membership: {
      remainingDays: "बाँकी दिनहरूको संख्या",
      type: "सदस्यताको प्रकार",
      validity: "सदस्यताको वैधता",
      validityLength: {
        custom: "अनुकूलन",
        expired: "म्याद सकियो।",
        oneTo8Months: "1-8 months",
        lessThan1Month: "1 महिनाभन्दा कम",
        moreThan1Month: "1 वर्षभन्दा बढी",
        sixTo12Months: "6-12 महिना",
      },
    },
    of: "को",
    ok: "ठिक छ",
    statusItems: {
      closed: "बन्द भयो",
      open: "खोल्नुहोस्",
    },
    orderByItems: {
      all: "सबै",
      dateAscending: "बढिरहेको मिति",
      dateDescending: "घटिरहेको मिति",
      dueDate: "अन्तिम मिति",
      high: "उच्च",
      low: "कम",
      medium: "मध्यम",
    },
    orderBy: "निम्न विषयद्वारा अर्डर गर्नुहोस्",
    select: "छनौट गर्नुहोस्।",
    type: "प्रकार ",
    uploadImageVideo: "तस्विर/भिडियोहरू अपलोड गर्नुहोस्",
    user: "प्रयोगकर्ता",
    userName: "प्रयोगकर्ताको नाम",
    usersSelected: "प्रयोगकर्ता छनौट गरियो",
    topics: "विषयहरू",
    date: "मिति",
    addNew: "नयाँ थप्नुहोस्",
    exportAsCsv: "सीएसभीको रूपमा एक्सपोर्ट गर्नुहोस्",
    noData: "कुनै डाटा फेला परेन",
    login: {
      welcomeMsg: "स्वागत छ! लग-इन गर्नुहोस्",
      info: "आफ्नो परिचय खुल्ने प्रमाणहरू प्रविष्ट गर्नुहोस्।",
      forgot: "पासवर्ड बिर्सनुभयो कि?",
      btn: "लग-इन गर्नुहोस्",
      unableToLogin: "लगइन गर्न असमर्थ रहेको छ",
    },
    forgot: {
      info_l1:
        "कृपया आफ्नो खातासँग सम्बन्धित इमेल ठेगाना प्रविष्ट गर्नुहोस्। पासवर्ड विवरणहरू तपाईंको इमेल ठेगानामा पठाइनेछ।",
      info_l2:
        "कृपया आफ्नो खातासँग सम्बन्धित आफ्नो मोबाइल नम्बर प्रविष्ट गर्नुहोस्। पासवर्ड विवरणहरू फोन नम्बरमा पठाइनेछ।",
      info_l3:
        "तपाईंको पासवर्ड कसरी रिसेट गर्ने भन्ने बारेमा निर्देशनहरू प्राप्त गर्नको लागि कृपया निम्न विकल्पहरू मध्ये एउटा छान्नुहोस्।",
      forgotQ: "तपाईंको आफ्नो पासवर्ड बिर्सनुभयो कि?",
      loginNow: "अहिले लगइन गर्नुहोस्",
      resetSucc: "तपाईंको पासवर्ड सफलतापूर्वक रिसेट गरियो",
      resetSucc_l2:
        "तपाईं अब आफ्नो खातामा लगइन गर्न आफ्नो नयाँ पासवर्ड प्रयोग गर्न सक्नुहुन्छ।",
      entPsw: "कृपया आफ्नो नयाँ पासवर्ड प्रविष्ट गर्नुहोस्।",
      resetPsw: "आफ्नो पासवर्ड रिसेट गर्नुहोस्",
      resendOTP: "ओटिपि पुन: पठाउनुहोस्",
      enterCorrectOTP: "कृपया सही ओटिपि प्रविष्ट गर्नुहोस्।",
      enterOTP: "कृपया इमेल/मोबाइलमा प्राप्त भएको ओटिपि प्रविष्ट गर्नुहोस्",
      backToLoginPage: "लगइन पृष्ठमा फर्कनुहोस्।",
      recieveCodeFalse: "मैले कोड प्राप्त गरिन।",
    },
    userslist: {
      createNewUser: "Create a New User",
      chooseCreateType: "Please choose one of the following options:",
      addNewUser: "नयाँ प्रयोगकर्ता थप्नुहोस्",
      editUser: "प्रयोगकर्ता इडिट गर्नुहोस्",
      addNewAdmin: "एडमिन प्रयोगकर्ता थप्नुहोस्",
      userLoading: "प्रयोगकर्ताहरू लोड गर्दैछ... कृपया प्रतिक्षा गर्नुहोस्",
      noUser: "कुनै प्रयोगकर्ता उपलब्ध छैन",
      extendVal: "वैधता विस्तार गर्नुहोस्।",
      extendReason: "विस्तार गरेको कारण",
      extendReasonMsg: "सदस्यता विस्तारको कारण खुलाउनुहोस्।",
      exportAsCSV: "सीएसभीको रूपमा एक्सपोर्ट गर्नुहोस्",
      membershipType: "सदस्यताको प्रकार",
      membershipValidity: "सदस्यताको वैधता",
      regionState: "क्षेत्र/राज्य",
      cityTown: "शहर/नगर",
      clearAll: "सबै खाली गर्नुहोस्",
      search: "खोज",
    },
    addEdituser: {
      firstNameRequired: "पहिलो नाम आवश्यक छ",
      firstNameOllyAlpha: "पहिलो नाममा अक्षरहरू मात्रै समावेश हुन सक्दछ",
      firstNameLimit: "पहिलो नाम 15 वर्णभन्दा कमको हुनु पर्दछ",
      lastNameRequired: "अन्तिम नाम आवश्यक छ",
      lastNameOllyAlpha: "अन्तिम नाममा अक्षरहरू मात्रै समावेश हुन सक्दछ",
      lastNameLimit: "अन्तिम नाम 15 वर्णभन्दा कमको हुनु पर्दछ",
      emailReuired: "इमेलको आवश्यकता छ",
      emailInvalid: "अमान्य इमेलको ढाँचा",
      mobileRequired: "मोबाइल नम्बरको आवश्यकता छ",
      invalidMobile: "अमान्य मोबाइल नम्बरको ढाँचा",
      pswRequired: "पासवर्ड आवश्यक छ",
      deptRequired: "विभाग आवश्यक छ",
      roleRequired: "भूमिका आवश्यक छ",
      countryRequired: "देशको कोड आवश्यक छ",
      userUpdated: "प्रयोगकर्ता अपडेट गरियो",
      userNotUpdated: "प्रयोगकर्ता अपडेट गरिएको छैन",
      activateAct: "खाता सक्रिय गर्नुहोस्",
      deactivateAct: "खाता निष्क्रिय गर्नुहोस्",
      userActivated: "प्रयोगकर्ता सक्रिय गरियो",
      userDeactivated: "प्रयोगकर्ता निष्क्रिय गरियो",
      deactivateUser: "प्रयोगकर्ता निष्क्रिय गर्नुहोस्",
      deactivateMsg:
        "के तपाईं आफू प्रयोगकर्ताको स्थिति परिवर्तन गर्न चाहनुहुन्छ भनेर पक्का हुनुहुन्छ?",
      userAdded: "प्रयोगकर्ता थपियो",
      userNotAdded: "प्रयोगकर्ता थपिएको छैन",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "एप प्रयोगकर्ता एडिट गर्नुहोस्",
    },
    permissions: {
      savePermissions: "अनुमतिहरू सेभ गर्नुहोस्",
      moduleName: "मोड्युलको नाम",
      view: "हेर्नुहोस्",
      create: "सिर्जना गर्नुहोस्",
      update: "अपडेट गर्नुहोस्",
      delete: "डिलिट गर्नुहोस्",
      permissionsUpdated: "अनुमतिहरू अपडेट गरियो",
      permissionsNotUpdated: "अनुमतिहरू अपडेट गरिएको छैन",
      selectMembership: "सदस्यता छनौट गर्नुहोस्।",
      noPermMsg:
        "कृपया आफ्नो अनुमतिहरू हेर्न माथिको 'सदस्यताको प्रकार' ड्रप डाउन प्रयोग गरेर सदस्यताको प्रकार छनौट गर्नुहोस्",
      selectRoleMsg: "कृपया अनुमतिहरू देखाउन माथिको भूमिका छनौट गर्नुहोस्।",
    },
    logs: {
      time: "समय",
      username: "प्रयोगकर्ताको नाम",
      role: "भूमिका",
      terminalID: "टर्मिनल आईडी",
      moduleAccessed: "पहुँचको मोड्युल",
      typeOfAccess: "पहुँचको प्रकार",
      activityLogDetails: "गतिविधिको लग विवरण",
      userId: "प्रयोगकर्ताको आईडी",
      lastLogin: "पछिल्लो लगइन",
      geoAccPoint: "भौगोलिक पहुँच बिन्दु",
      ipAdd: "आईपी ​​ठेगाना",
      filesAccessed: "फाइलहरू पहुँच गरियो",
      funAccessed: "कार्य पहुँच गरियो",
      webUrl: "वेब पृष्ठ युआरएल",
      unsuccAtmp: "असफल लगइन प्रयास",
      view: "हेर्नुहोस्",
      membershipType: "सदस्यताको प्रकार",
    },
    profileSetting: {
      profileAuthSettings: "प्रोफाइल प्रमाणीकरण सेटिङहरू",
      changeSettings: "सेटिङहरू परिवर्तन गर्नुहोस्",
      loginLogoutSettings: "लगइन/लगआउट सेटिङहरू",
      autoLogout: "स्वतः लगआउट",
      unsuccAtmp: "असफल लगइन प्रयासहरू",
      unsuccLoginLock: "असफल लगइन लक-आउट अवधि",
      pswCrisetup: "पासवर्ड मापदण्ड सेटअप",
      pswLength: "पासवर्डको लम्बाइ",
      noOfUniquePsw: "खास पासवर्डहरूको संख्या आवश्यक छ",
      maxPswAge: "अधिकतम पासवर्ड समय",
      AccRangeOfchars: "वर्णहरूको स्वीकार्य दायरा",
      upperCase: "अप्पर केस",
      lowerCase: "लोअर केस",
      numbers: "संख्याहरू",
      specialChars: "विशेष वर्ण",
      settingsUpdated: "सेटिङहरू अपडेट गरियो",
      settingsNotUpdated: "सेटिङहरू अपडेट गरिएको छैन",
    },
    dashboardSection: {
      modules: "मोड्युलहरू",
      allowances: "भत्ताहरू",
      maxUserAllowed: "अधिकतम प्रयोगकर्ताहरूलाई अनुमति दिइएको छ",
      satelliteReportsAllowed: "स्याटेलाइट रिपोर्टहरूलाई अनुमति दिइएको छ",
      advanceReport: "उन्नत रिपोर्टहरूलाई अनुमति दिइएको छ",
      subscriptionUpTo: "निम्न मितिसम्मको सदस्यता",
      roleAllowed: "भूमिकाहरूलाई अनुमति दिइएको छ",
      moduleAllowed: "मोड्युलहरूलाई अनुमति दिइएको छ",
      registeredUsers: "दर्ता भएका प्रयोगकर्ताहरू",
      validMemberships: "मान्य सदस्यताहरू",
      activeUsers: "सक्रिय प्रयोगकर्ताहरू",
      deactivatedUsers: "डिएक्टिभेट गरिएका प्रयोगकर्ताहरू",
      membershipValidity: "सदस्यता वैधता",
      lessThan1Month: "1 महिनाभन्दा कम",
      months1to6: "1-6 महिना",
      months6to12: "6-12 महिना",
      moreThan1Year: "1 वर्षभन्दा बढी",
      cropOverview: "अन्नबालीको अवलोकन",
      plantations: "बिरूवा रोप्ने",
      coffeeData: "कफी डाटा",
      availableModules: "उपलब्ध मोड्युलहरू",
      roleList: "किसान, खरीद स्टेशन, गोदाम",
      memberData: "सदस्य डाटा",
      userType: "प्रयोगकर्ता प्रकार",
      registered: "पंजीकृत",
      offlineUsers: "अफलाइन प्रयोगकर्ता",
      lessThanOneMonth: "१ महिना भन्दा कम",
      cacaoData: "काकाओ डाटा",
      dryCacao: "सुक्खा काकाओ",
      traceability: "प्रतिपुस्तिकरण",
    },
    adminRoles: {
      adminRoles: "एडमिनका भूमिकाहरू",
      roleName: "भूमिकाको नाम",
      description: "विवरण",
      viewPermissions: "अनुमतिहरू हेर्नुहोस्",
      createAdminRole: "एडमिन भूमिका सिर्जना गर्नुहोस्",
      enterDesHere: "यहाँ आफ्नो विवरण प्रविष्ट गर्नुहोस्",
      deleteRole: "भूमिका डिलिट गर्नुहोस्",
      deleteMsg: "के तपाईं भूमिका डिलिट गर्न निश्चित हुनुहुन्छ?",
      roleReq: "भूमिकाको नाम आवश्यक रहेको छ।",
      roleLimit: "भूमिकाको नाम 15 वर्णभन्दा कमको हुनु पर्दछ।",
      desReq: "विवरण आवश्यक रहेको छ।",
      desLimit: "विवरण 40 वर्ण वा कम हुनु पर्दछ।",
      roleSuccess: "भूमिका सफलतापूर्वक सिर्जना गरियो।",
      editAdminRole: "एडमिनको भूमिका एडिट गर्नुहोस्",
      roleUpdated: "भूमिका अपडेट गरियो",
      noRole: "कुनै एडमिनको भूमिकाहरू फेला परेनन्",
      noRoleMsg:
        "कृपया माथिको 'एडमिन भूमिका सिर्जना गर्नुहोस्' बटन प्रयोग गरेर एडमिनको भूमिका सिर्जना गर्नुहोस्",
    },
    membershipplanSection: {
      defaultPlan: " पूर्वनिर्धारित योजना",
      planType: "योजनाको प्रकार",
      planDuration: "योजनाको अवधि",
      planFee: "योजनाको शुल्क",
      satelliteReport: "स्याटेलाइट रिपोर्टहरू",
      advanceReport: "अग्रिम रिपोर्ट",
      addMembership: "सदस्यता थप्नुहोस्",
      addMembershipPlan: "सदस्यता योजना थप्नुहोस्",
      editMembershipPlan: "सदस्यता योजना एडिट गर्नुहोस्",
      accessSetelite: "स्याटेलाइट रिपोर्टहरूमा पहुँच (5 वटा रिपोर्टहरूको सेट)",
      accessAdvanceReport: "उन्नत रिपोर्टहरूमा पहुँच",
      memPlanReq: "सदस्यताको योजना आवश्यक रहेको छ।",
      memPlanReqLimit: "सदस्यताको योजना 20 वर्णभन्दा कम हुनु पर्दछ।",
      SatelliteReq: "स्याटेलाइट रिपोर्ट आवश्यक रहेको छ।",
      advancedReportReq: "उन्नत रिपोर्ट आवश्यक रहेको छ।",
      durationReq: "सदस्यता अवधि आवश्यक रहेको छ।",
      feeReq: "सदस्यता शुल्क आवश्यक रहेको छ।",
      cantLesThenZero: "0 भन्दा कम हुन सक्दैन।",
      roleReq: "प्रयोगकर्ताको भूमिका आवश्यक रहेको छ।",
    },
    tickets: {
      actions: {
        create: "टिकट सिर्जना गर्नुहोस्",
        delete: "टिकट डिलिट गर्नुहोस्।",
        edit: "टिकट एडिट गर्नुहोस्।",
      },
      areaOfRequest: "अनुरोध क्षेत्र",
      assignee: "तोकिएको व्यक्ति",
      deleteTicket: {
        confirmation:
          "के तपाईं आफूले {0} टिकट डिलिट गर्न चाहनुभएको कुरामा पक्का हुनुहुन्छ?",
      },
      dueDate: "अन्तिम मिति",
      filters: {
        ticketFor: "निम्न कुराको लागि टिकट",
      },
      form: {
        ticketType: {
          admin: "दिमित्रा एडमिनको लागी टिकट सिर्जना गर्नुहोस्",
          user: "एप प्रयोगकर्ताको लागि टिकट सिर्जना गर्नुहोस्",
        },
      },
      markAsRead: "पढिसकेको भनेर चिन्ह लगाउनुहोस्",
      messages: {
        created: {
          success: "टिकट सफलतापूर्वक सिर्जना गरियो।",
        },
        deleted: {
          success: "टिकट सफलतापूर्वक डिलिट भयो।",
        },
      },
      noData: "कुनै पनि टिकट भेटिएन!",
      noDataHelpText:
        "तपाईंलाई अहिलेसम्म कुनै पनि टिकट तोकिएको छैन। सुरु गर्नको लागि यस स्क्रिनको माथि रहेको 'टिकट सिर्जना गर्नुहोस्' बटनमा क्लिक गर्नुहोस्।",
      pickerInMenu: "मेनुको पिकर",
      priority: {
        high: "उच्च",
        label: "प्राथमिकता",
      },
      reply: "उत्तर दिनुहोस्।",
      requestedDateTime: "अनुरोध गरिएको मिति र समय",
      requestorDetails: "अनुरोधकर्ताको विवरण",
      requestorEmail: "अनुरोधकर्ता इमेल",
      subject: "विषय",
      ticketsForItems: {
        all: "सबै",
        dimitraAdmin: "दिमित्रा एडमिन",
        multipleUsers: "धेरै प्रयोगकर्ताहरू",
        singleUser: "एकल प्रयोगकर्ता",
      },
      title: "टिकटहरू",
    },
    roleRequest: {
      roleRequest: "भूमिकाको अनुरोध",
      userRole: "प्रयोगकर्ताको भूमिका",
      approve: "स्वीकृत गर्नुहोस्",
      reject: "अस्वीकृत गर्नुहोस्",
      username: "प्रयोगकर्ताको नाम",
      email: "इमेल",
      phone: "फोन",
      roleAssigned: "भूमिका तोकियो",
      roleRequested: "भूमिका अनुरोध गरिएको छ",
      requestedDate: "अनुरोध गरिएको मिति",
      updateRoleRequest: "भूमिकाको अनुरोध अपडेट गर्नुहोस्",
      message: "सन्देश",
      update: "अपडेट गर्नुहोस्",
    },
    faqSection: {
      createFaq: "एफएक्यू सिर्जना गर्नुहोस्",
      createTopic: "विषय सिर्जना गर्नुहोस्",
      selectTopic: "विषय छनौट गर्नुहोस्",
      faqQuestion: "एफएक्यू प्रश्न",
      faqAnswer: "एफएक्यू उत्तर",
      uploadImgVid: "तस्विर/भिडियो अपलोड गर्नुहोस्",
      disInFaq: "एफएक्यू खण्डमा डिस्प्ले गर्नुहोस्",
      editFaq: "एफएक्यू एडिट गर्नुहोस्",
      topicName: "विषयको नाम",
      parentTopic: "अभिभावकको विषय",
      editTopic: "विषय एडिट गर्नुहोस्",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "किसानको नाम",
      farmerProdChart: "किसानको उत्पादन चार्ट",
      production: "उत्पादन",
      byProduction: "उत्पादनद्वारा",
      byName: "नामद्वारा",
      descending: "घटिरहेको",
      ascending: "बढिरहेको",
      buyingStationProdChart: "स्टेशन उत्पादन चार्ट खरीद",
      buyingStation: "खरिद गर्ने स्टेशन",
      buyingStationName: "स्टेशनको नाम किन्दै",
      dryMilling: "ड्राई मिलिङ",
      dryMillingName: "ड्राई मिलिङ नाम",
      dryMillingProdChart: "ड्राई मिलिङ उत्पादन चार्ट",
      view: "हेर्नुहोस्",
      date: "मिति",
    },
    cacaoTraceability: {
      traceability: "पूर्वपुस्तीकरण",
      cacaoTraceabilityMngmnt: "काकाओ पूर्वपुस्तीकरण प्रबन्धन",
      traceabilityPage: "पूर्वपुस्तीकरण पृष्ठ",
      labelDesigner: "लेबल डिजाइनर",
      additionalInformation: "थप जानकारी",
      info1:
        "तपाईंको उत्पादका अतिरिक्त लोगोहरूको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
      addSlogan: "स्लोगन थप्नुहोस्",
      additionalLogos: "थप लोगोहरू",
      title: "शीर्षक",
      description: "विवरण",
      mapLink: "नक्सा लिंक",
      websiteLink: "वेबसाइट लिंक",
      addMedia: "मिडिया थप्नुहोस्",
      uploadImageVideo: "चित्र/भिडियो अपलोड गर्नुहोस्",
      origin: "मूल",
      info2:
        "तपाईंको उत्पादको मूल देशका बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
      countryImage: "देश चित्र",
      institutionalInfo: "संस्थागत जानकारी",
      info3:
        "तपाईंको कम्पनी/सहकारीका बारेमा जानकारी प्रदान गर्नुहोस्, उपभोक्ताहरूलाई तपाईंको कामका बारेमा बताउनुहोस्। यस जानकारीले काकाओ पूर्वपुस्तीकरण पृष्ठमा सार्वजनिक गरिएको छ।",
      cooperativeLogo: "सहकारी लोगो",
      traceabilityIntro: "पूर्वपुस्तीकरण परिचय",
      info4:
        "यस खण्डले उपभोक्तालाई कफि उत्पादन र प्रसंस्करणका पूरा इतिहासमा पहुँच प्रदान गर्दछ। तपाईंको कम्पनी/सहकारीको र पूर्वपुस्तीकरणको महत्त्वको बारेमा बयान गर्दछ।",
      addLabel: "लेबल थप्नुहोस्",
      chooseTitle: "शीर्षक छनोट गर्नुहोस्",
      chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट छनोट गर्नुहोस्",
      uploadYourLogo: "तपाईंको लोगो अपलोड गर्नुहोस्",
      info5:
        "सुचना: चित्रको आकार कम्तिमा 1000 x 1000 पिक्सल वर्ग गर्नुपर्छ। तपाईं जस्तो पृष्ठभूमि रंगसँग सिङ्क गर्न Transparent PNG छनोट गर्न सक्दैछ।",
      chooseTemplateColors: "टेम्प्लेट रङ्गहरू छनोट गर्नुहोस्",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "मुख्य रंग",
      labelStatus: "लेबल स्थिति",
      inactive: "निष्क्रिय",
      download: "डाउनलोड गर्नुहोस्",
      enterLabelTitle: "लेबल शीर्षक प्रविष्टि गर्नुहोस्",
    },
    setting: {
      profileAuthSetting: "प्रोफाइल प्रमाणीकरण सेटिङहरू",
      logInOutSetting: "लगइन/लगआउट सेटिङहरू",
      autoLogout: "स्वतः लगआउट",
      unsuccessfulLoginAttempt: "असफल लगइन प्रयासहरू",
      unsuccessfulLoginLockPeriod: "असफल लगइन लक-आउट अवधि",
      passCriteriaSetup: "पासवर्ड मापदण्ड सेटअप",
      passLength: "पासवर्डको लम्बाइ",
      noUniquePassRequired: "खास पासवर्डहरूको संख्या आवश्यक छ",
      maxPassAge: "अधिकतम पासवर्ड समय",
      acceptableRangeOfChars: "वर्णहरूको स्वीकार्य दायरा",
      upperCase: "अप्पर केस",
      lowerCase: "लोअर केस",
      numbers: "संख्याहरू",
      specialChars: "विशेष वर्ण",
      uniqueSymbols: "खास प्रतिक",
      loadingData: "डाटा लोड गर्दैछ...",
      currency: "मुद्रा",
      codeActivationTime: "कोड एक्टिभेसन समय",
      changeGlobalSetting: "ग्लोबल सेटिङहरू परिवर्तन गर्नुहोस्",
      globalSetting: "ग्लोबल सेटिङहरू",
      generalSetting: "सामान्य सेटिङहरू",
      hour: "घण्टा",
      days: "दिन",
      minutes: "मिनेट",
      perDay: "प्रति दिन",
      perHour: "प्रति घण्टा",
      customised: "अनुकूलित",
    },
    traceability: {
      traceability: "परिपुर्णता",
      coffeeTraceabilityMngmnt: "कफी परिपुर्णता प्रबन्धन",
      traceabilityPage: "परिपुर्णता पृष्ठ",
      labelDesigner: "लेबल डिजाइनर",
      additionalInformation: "थप जानकारी",
      info1:
        "तपाईंको उत्पादको थप लोगोहरूको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
      addSlogan: "स्लोगन थप्नुहोस्",
      additionalLogos: "थप लोगोहरू",
      title: "शीर्षक",
      description: "वर्णन",
      mapLink: "नक्शा लिंक",
      websiteLink: "वेबसाइट लिंक",
      addMedia: "मिडिया थप्नुहोस्",
      uploadImageVideo: "तस्वीर/भिडियो अपलोड गर्नुहोस्",
      origin: "मूल",
      info2:
        "तपाईंको उत्पादको मूल देशको बारेमा जानकारी प्रदान गर्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
      countryImage: "देश तस्वीर",
      institutionalInfo: "संस्थागत जानकारी",
      info3:
        "तपाईंको कम्पनी/सहकारीका बारेमा जानकारी प्रदान गर्नुहोस्, उपभोक्तालाई तपाईंले गरेका सम्बन्धित कामका बारेमा भन्नुहोस्। यस जानकारी कफी परिपुर्णता पृष्ठमा सार्वजनिक गरिएको छ।",
      cooperativeLogo: "सहकारीको लोगो",
      traceabilityIntro: "परिपुर्णता परिचय",
      info4:
        "यस खण्डले उपभोक्तालाई कफीको पूरा उत्पादन र प्रसंस्करण इतिहासमा पहुँच दिनेछ। तपाईंको कम्पनी/सहकारीमा परिपुर्णताको महत्त्व र विश्वको लागि महत्त्व बयान गर्दछ।",
      addLabel: "लेबल थप्नुहोस्",
      chooseTitle: "शीर्षक छनौट गर्नुहोस्",
      chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट छनौट गर्नुहोस्",
      uploadYourLogo: "तपाईंको लोगो अपलोड गर्नुहोस्",
      info5:
        "सूचना: तस्वीरको आकार कम्तिमा 1000 x 1000 पिक्सेल वर्ग हुनुपर्छ। तपाईं बैकग्राउन्ड रंगको समानुप्रेषण गर्नका लागि पारदर्शी PNG छनौट गर्न सक्दैनुहुनेछ।",
      chooseTemplateColors: "टेम्प्लेट रंग छनौट गर्नुहोस्",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "पूर्वभूमि रंग",
      labelStatus: "लेबल स्थिति",
      inactive: "निष्क्रिय",
      download: "डाउनलोड गर्नुहोस्",
      enterLabelTitle: "लेबल शीर्षक प्रविष्ट गर्नुहोस्",
    },
    coffeeData: {
      windBreaker: "हावा छिर्ने विन्ड ब्रेकर रूख",
      horticultureInfo: "बागवानीको रूख",
      shadeTree: "छायाँ आउने रुख",
      coffeeVariety: "कफी विविधता",
      coffeeSpecies: "कफीका प्रजातिहरू",
      updateWindBreaker:
        "हावा छिर्ने विन्ड ब्रेकर रूखको प्रकार अपडेट गर्नुहोस्।",
      addWindBreaker:
        "नयाँ पङ्तिमा रोपिएका विन्ड ब्रेकर ट्रीको प्रकार थप्नुहोस्",
      updateHorticultureInfo:
        "बागवानीको जानकारी भएको रूखको प्रकार अपडेट गर्नुहोस्।",
      addHorticultureInfo: "नयाँ बागवानी जानकारी भएको रूखको प्रकार थप्नुहोस्।",
      updateShadeTree: "छाँया आउने रूखको प्रकार अपडेट गर्नुहोस्।",
      addShadeTree: "नयाँ कफीका विविधता भएको रूखको प्रकार थप्नुहोस्।",
      updateCoffeeVariety: "कफीको विविधता भएको रूखको प्रकार अपडेट गर्नुहोस्।",
      addCoffeeVariety: "नयाँ कफीका विविधता भएको रूखको प्रकार थप्नुहोस्।",
      deleteVarietyTitle: "विविधता डिलिट गर्नुहोस्।",
      deleteVarietyMessage: "के तपाईं विविधता डिलिट गर्न निश्चित हुनुहुन्छ?",
      updateCoffeeSpecie: "कफीको प्रजाति अपडेट गर्नुहोस्।",
      deleteSpecieTitle: "प्रजाति डिलिट गर्नुहोस्।",
      deleteSpecieMessage: "के तपाईं प्रजाति डिलिट गर्न चाहनुभएको पक्का हो?",
      addCoffeeSpecie: "नयाँ कफीको प्रजाति थप्नुहोस्।",
      variety: "विविधता",
      selectVariety: "विविधता छनौट गर्नुहोस्।",
      deleteCoffeeRecord: "के तपाईं रेकर्ड डिलिट गर्न निश्चित हुनुहुन्छ?",
      deleteCoffeeData: "कफीको डाटा डिलिट गर्नुहोस्",
      topicRequired: "विषयको नाम आवश्यक रहेको छ।",
      coffeeAddSuccess: "कफीको प्रजाति सफलतापूर्वक थपियो।",
      treeTypeSuccess: "रुखको प्रकार सफलतापूर्वक थपियो।",
      treeTypeUpdateSuccess: "रूखको प्रकार सफलतापूर्वक अपडेट गरियो।",
      coffeeVarietySuccess: "कफीको विविधता सफलतापूर्वक थपियो।",
      coffeeSpecieSuccess: "कफीको प्रजाति सफलतापूर्वक अपडेट गरियो।",
      nameRequired: "नाम आवश्यक रहेको छ।",
      notFound: "कुनै एडमिन कफी डाटा फेला परेन।",
    },
    cacaoData: {
      cacao: "काकाओ",
      cacaoVariety: "काकाओ प्रकार",
      cacaoSpecies: "काकाओ प्रजाति",
      deleteCacaoData: "काकाओ डाटा मेटाउनुहोस्",
    },
    plantation: {
      farmerName: "किसानको नाम",
      phoneNumber: "फोन नम्बर",
      plantationName: "रोपेको बिरुवाको नाम",
      farm: "फार्म",
      location: "स्थान",
      updatePlantationStatus: "बिरुवा रोपेको स्थिति अपडेट गर्नुहोस्।",
      update: "अपडेट गर्नुहोस्",
    },
    surveyBuilder: {
      addNewSurvey: "नयाँ सर्वेक्षण थप्नुहोस्",
      surveyTitle: "सर्वेक्षण शीर्षक",
      surveyName: "सर्वेक्षण नाम",
      surveyDescription: "सर्वेक्षण विवरण",
      describeSurvey: "सर्वेक्षणको बारेमा वर्णन गर्नुहोस्",
      enableScheduling: "समय सारणी सक्षम गर्नुहोस्",
      selectedDate: "चयनित मिति",
      multiStepSurvey: "बहु-कदम सर्वेक्षण",
      multiStepSurveyDetails:
        "प्रति कदममा प्रश्नको संख्यामा आधारित, सर्वेक्षणका सबै प्रश्नहरूलाई कदमहरूमा ग्रुप गरिन्छ र प्रदर्शन गरिन्छ।",
      multiStep: "बहु-कदम",
      noQuestionEachStep: "प्रति कदममा प्रश्नको संख्या",
      surveyStatus: "सर्वेक्षण स्थिति",
      surveyStatusDetails:
        "सर्वेक्षणमा प्रश्न थप्दा मात्र सक्षम गर्न सकिन्छ। सर्वेक्षण सक्षम गर्दा किसानहरूले प्रस्तुति गर्न सक्दैन्।",
      selectUsers: "प्रयोगकर्ताहरू चयन गर्नुहोस्",
      selectUsersDetails:
        "यदि प्रयोगकर्ता चयन गरिएको छ भने सर्वेक्षण सबै प्रयोगकर्ताहरूको लागि उपलब्ध हुनेछ। यदि तपाईं प्रयोगकर्ता चयन सक्षम गर्नुहुन्छ भने तपाईं पर्वाहरूका बीचमा केहि प्रयोगकर्ताहरू चयन गर्न सक्नुहुन्छ।",
      linkWithFarms: "खेतहरूसँग संयोजन गर्नुहोस्",
      linkWithFarmsDetails:
        "यदि सक्षम गरिएको छ भने सर्वेक्षण व्यक्तिगत खेतहरूसँग संयोजन गरिनेछ। यदि किसानको पास केहि खेतहरू छन् भने प्रत्येक खेतलाई आफ्नो सर्वेक्षण छ।",
      enabled: "सक्षम गरिएको",
      disabled: "निष्क्रिय गरिएको",
      cancel: "रद्द गर्नुहोस्",
      next: "अर्को",
      surveySettings: "सर्वेक्षण सेटिङ्ग्स",

      selectSurveyUsers: "सर्भेक्षण गर्नका लागि प्रयोगकर्ता चयन गर्नुहोस्",
      selectToProceed: "कृपया अगाडि जानका लागि प्रयोगकर्ता(हरू) चयन गर्नुहोस्",
      searchUsers: "प्रयोगकर्ता खोज्नुहोस्",
      usersSelected: "प्रयोगकर्ता चयन गरिएको छ",
      conditional: "शर्तानुसार",
      autoConditional: "स्वच्छ शर्तानुसार",
      userName: "प्रयोगकर्ता नाम",
      email: "ईमेल",
      membershipType: "सदस्यता प्रकार",
      membershipValidity: "सदस्यता मान्यता",
      membershipRemainingDays: "बाँकी दिनको संख्या",
      membershipRole: "सदस्य भूमिका",
      accountProgress: "खाता प्रगति",
      status: "स्थिति",
      active: "सक्रिय",
      deactivated: "निष्क्रिय",
      continue: "जारी राख्नुहोस्",
      questions: "प्रश्नहरू",
      responses: "प्रतिक्रियाहरू",
      deleteSurvey: "सर्भेक्षण मेट्नुहोस्",
      editSurvey: "सर्भेक्षण सम्पादन गर्नुहोस्",
      type: "प्रकार",
      compulsory: "अपरिहार्य",
      createSurvey: "सर्भेक्षण बनाउनुहोस्",
      surveyBuilder: "सर्भेक्षण निर्माता",
      surveyList: "सर्भेक्षण सूची",
      farm: "खेत",
      responseDate: "प्रतिक्रिया मिति",
      viewSurvey: "सर्भेक्षण हेर्नुहोस्",
      question: "प्रश्न",
      settings: "सेटिङ्ग्स",
      addQuestion: "प्रश्न थप्नुहोस्",
      surveysSubmitted: "सर्भेक्षण पेश गरिएका छन्",
      surveyDetail: "सर्भेक्षण विवरण",
      conditionStatus: "शर्त स्थिति",
      conditionStatusDesc:
        "शर्तहरू सानोमा गर्ने प्रयोगकर्तालाई स्वच्छप्रमुख सर्भेक्षणका लागि पात्र बनाउँछ।",

      endSurvey: "सर्भेय समाप्त गर्नुहोस्",
      publishSurvey: "सर्भेय प्रकाशित गर्नुहोस्",
      copy: "प्रतिलिपि बनाउनुहोस्",
      view: "हेर्नुहोस्",
      startDate: "प्रारम्भ मिति",
      endDate: "समाप्ति मिति",
      chooseDate: "मिति छनोट गर्नुहोस्",
      select: "चयन गर्नुहोस्",
      addSurveyQuestion: "सर्भेय प्रश्न थप्नुहोस्",
      editSurveyQuestion: "सर्भेय प्रश्न सम्पादन गर्नुहोस्",
      questionScore: "प्रश्न योग्यता",
      mandatory: "अनिवार्य",
      yes: "हो",
      no: "होइन",
      options: "विकल्पहरू",
      typeHere: "यहाँ प्रक्षिप्त गर्नुहोस्",
      add: "थप्नुहोस्",
      optionsHint:
        'कृपया उत्तर दिनका लागि प्रवेश गर्नुहोस् वा "थप्नुहोस्" मा क्लिक गर्नुहोस्',
      surveyProgress: "प्रगतिमा सर्भेय",
      allResponses: "सबै प्रतिक्रिया संक्षेपण",
      responseQuestion: "प्रश्न अनुसार प्रतिक्रिया",
      dateSubmitted: "प्रस्तुत मिति",
      answer: "उत्तर",
      totalScore: "कुल योग्यता",
      score: "योग्यता",
      singleSelection: "एकल चयन",
      multipleSelection: "बहुचयन",
      if: "यदि",
      then: "त्यसपछि",
      noResponse: "कुनै प्रतिक्रिया छैन",
      noSurveyFound: "कुनै प्रश्नसंग सर्भेय प्राप्त गर्न असक्षम!",
      createNewSurvey:
        'कृपया "सर्भेय बनाउनुहोस्" बटन प्रयोग गरेर सर्भेय बनाउनुहोस्',
      cannotPublish: "अक्षम सर्भेय प्रकाशन गर्नुहोस्!",
      deleteSurveyWarn:
        "के तपाईं सर्भेय मेटाउन चाहनुहुन्छ? यदि तपाईं मेटाउनुहुन्छ भने सबै सर्भेय प्रश्न र प्रस्तुतिहरू पूर्णरूपमा मेटिनेछ।",
      noQuestionFound: "कुनै प्रश्न प्राप्त गर्न असक्षम!",
      createQuestion:
        'कृपया "प्रश्न थप्नुहोस्" बटन प्रयोग गरेर पहिलो प्रश्न थप्नुहोस्',
      deleteQuestion: "के तपाईं प्रश्न मेटाउन चाहनुहुन्छ?",
      applyChanges: "तपाईं यस परिवर्तनलाई कसरी लागू गर्न चाहनुहुन्छ?",
      editFutureSurveys: "भविष्यक सर्भेयहरू मात्र सम्पादन गर्नुहोस्",
      editLiveSurveyOnly: "मात्र लाइभ सर्भेय सम्पादन गर्नुहोस्",
      surveyIsLive:
        "कृपया ध्यान दिनुहोस् कि सर्भेय वर्तमानमा लाइभ छ र यस समय प्रश्न सम्पादन गर्दा पूर्व प्रस्तुतिहरूमा प्रभाव पार्न सक्दछ। कुनै समस्या रोक्न यसका लागि, तपाईं प्रश्नमा परिवर्तन गर्नका लागि सर्भेयको प्रतिलिपि बनाउन सक्नुहुन्छ।",
      clickToCopy: "सर्भेय प्रतिलिपि बनाउनका लागि यहाँ क्लिक गर्नुहोस्",
      applyChangesNow: "अप्लाई परिवर्तन अब",
      copySurvey: "सर्भेय प्रतिलिपि",
      changeCopySurveyName:
        "तपाईं प्रतिलिपि सर्भेय संस्करणको नाम परिवर्तन गर्न सक्नुहुन्छ।",
    },
    cropsReport: "फसल प्रतिवेदन",
    today: "आज",
    week: "सप्ताह",
    month: "महिना",
    year: "वर्ष",
    all: "सबै",
    cropsStatistics: "फसल तथ्याङ्क",
    crops: "फसलहरू",
    acres: "एकड",
    totalPlantedArea: "कुल रोपिएको क्षेत्र",
    farmersChart: "किसानहरूको चार्ट",
    cropsName: "फसलको नाम",
    farmers: "किसानहरू",
    farms: "कृषि फर्महरू",
    planted: "रोपिएको",
    plantedArea: "रोपिएको क्षेत्र",
    harvested: "प्राप्त गरिएको",
    yieldAcre: "प्रति एकड उत्पादन",
    selectCrop: "फसल छान्नुहोस्",
    listByYield: "उत्पादनद्वारा सूची गर्नुहोस्",
    listByPlantedArea: "रोपिएको क्षेत्रद्वारा सूची गर्नुहोस्",
    equipmentReport: "उपकरण प्रतिवेदन",
    equipmentChart: "उपकरण चार्ट",
    selectFarmer: "किसान छान्नुहोस्",
    equipmentName: "उपकरणको नाम",
    region: "क्षेत्र",
    counts: "गणना",
    large: "ठूलो",
    medium: "मध्यम",
    small: "सानो",
    listByFarmer: "किसानद्वारा सूची गर्नुहोस्",
    rowsPerPage: "प्रति पृष्ठ पंक्तिहरू",
    farmersReport: "किसानहरूको प्रतिवेदन",
    farmersStatistics: "किसानहरूको तथ्याङ्क",
    averageFarmerLand: "औसत किसानको जमीन",
    largeFarmers: "ठूला किसानहरू",
    mediumFarmers: "मध्यम किसानहरू",
    smallFarmers: "साना किसानहरू",
    listByLand: "जमिनद्वारा सूची गर्नुहोस्",
    listByFarm: "फार्मद्वारा सूची गर्नुहोस्",
    AvgLandAcre: "औसत जमिन/एकड",
    listbyCrop: "फसलद्वारा सूची गर्नुहोस्",
    listbyZone: "क्षेत्रद्वारा सूची गर्नुहोस्",
    farmName: "फार्मको नाम",
    zones: "क्षेत्रहरू",
    area: "क्षेत्र",
    goalsAchievedReport: "लक्ष्यहरू पूरा गरिएको प्रतिवेदन",
    listByCrops: "फसलहरू द्वारा सूची गर्नुहोस्",
    goalsAchievedChart: "लक्ष्य पूरा गरिएको चार्ट",
    goalsAchieved: "लक्ष्य पूरा गरिएको",
    goalsFailed: "लक्ष्य असफल भयो",
    successRate: "सफलता दर",
    achieved: "पूरा गरिएको",
    equipment: "उपकरणहरू",
    pests: "कीटहरू",
    regions: "क्षेत्रहरू",
    filterByCrops: "फसलद्वारा फिल्टर गर्नुहोस्",
    searchCrops: "फसलहरू खोज्नुहोस्",
    batchCode: "ब्याच कोड",
    batchRating: "ब्याच रेटिङ",
    MakeASelection: "चयन गर्नुहोस्",
    typeTotalCoffeeQuantity: "कुल कफी मात्रा प्रकार गर्नुहोस्",
    typeHumidity: "नमता प्रकार गर्नुहोस्",
    valueInPercent: "प्रतिशतमा मान",
    purchaseOrderRequired: "किनमेल आदेश आवश्यक छ",
    totalCoffeeCherryRequired: "कुल कफी चेरी आवश्यक छ",
    processTypeRequired: "प्रक्रिया प्रकार आवश्यक छ",
    stationInfo: "स्टेशन जानकारी",
    purchaseOrders: "किनमेल आदेशहरू",
    processingBatch: "प्रक्रिया ब्याच",
    processedCoffeeOutRequired: "प्रक्रियामा कफी आउट आवश्यक छ",
    lotNo: "लट नम्बर",
    addNewS: "नयाँ थप्नुहोस्",
    viewAll: "सबै हेर्नुहोस्",
    parchmentOut: "पार्चमेन्ट आउट",
    processingDone: "प्रक्रिया पूरा गरिएको",
    farmerLotID: "किसान र लट आइडी",
    weight: "श्रेणी",
    plantationSettings: "बगैचा सेटिङ्गहरू",
    PlantationsEachFarmerCanCreate:
      "प्रत्येक किसानले बनाउन सक्दैन बगैचा को संख्या",
    manageAdditionalPlantationRequests:
      "अतिरिक्त बगैचा अनुरोध प्रबन्ध गर्नुहोस्",
    autoApprove: "स्वच्छ्छ मान्यता दिन्छ",
    adminApprovalRequired: "प्रशासक मान्यता आवश्यक छ",
    close: "बन्द गर्नुहोस्",
    new_user: "नयाँ प्रयोगकर्ता",
    KGAcre: "के.जी./एकड",
    memberDataSection: {
      coffeeType: "कफे को प्रकार",
      buyingStationDetails: "खरिद केन्द्र विवरण",
      buyingStationUsers: "खरिद केन्द्र प्रयोगकर्ता",
      activityLog: "गतिविधि लग",
    },
  },
  oma: {
    //land suitability
    landSuitibility: "भूमि उपयुक्तता",
    landSuitibilityReport: "भूमि उपयुक्तता रिपोर्ट",
    generateNewReport: "नयाँ रिपोर्ट तयार गर्नुहोस्",
    operatorName: "अपरेटरको नाम",
    issueDate: "मुद्दा मिति",
    chooseYourLocation: "तपाईंको स्थान चयन गर्नुहोस्",
    getLandEvaluation: "जमीनको मूल्यांकन प्राप्त गर्नुहोस्",
    downloadPdfReport: "पीडीएफ रिपोर्ट डाउनलोड गर्नुहोस्",
    pleaseEnterCoordinateText:
      "कृपया खेतको स्थानको अंक हेर्नको लागि देशान्तर र अक्षांश प्रविष्ट गर्नुहोस्।",
    noRecordAvailable: "कुनै नतिजा उपलब्ध छैन।",
    overallScoreForLand: "भूमि उपयुक्तताको समग्र स्कोर",
    landEvaluation: "भूमि मूल्यांकन",
    unsuitable: "अनुपयुक्त",
    marginally: "संघटनशील",
    suitable: "उपयुक्त",
    moderately: "मध्यम",
    highly: "अत्यधिक",
    back: "पछाडि",
    search: "खोज्नुहोस्",
    showResults: "नतिजाहरू देखाउनुहोस्",
    //weather analysis
    weatherAnalysisReport: "मौसम विश्लेषण रिपोर्टहरू",
    weatherAnalysis: "मौसम विश्लेषण",
    getWeatherAnalysis: "मौसम विश्लेषण प्राप्त गर्नुहोस्",
    weatherReport: "मौसम रिपोर्ट",
    filterByDate: "मिति अनुसार फिल्टर गर्नुहोस्",
    insertCoordinateText:
      "फार्म (वा रूख) स्थानको उपर आक्षांशहरू (लाटिट्युड र लाइन्गिट्युड) राख्नुहोस्, वा तलको नक्सा प्रयोग गरेर फार्म (वा रूख) स्थानको सूचना देखाउनुहोस्।",
    addTreeGeolocation: "रूखको स्थान थप्नुहोस्",
    editTreeGeolocation: "रूखको स्थान सम्पादन गर्नुहोस्",
    plantationDate: "रोपनी मिति",
    notes: "नोट्स",
    uploadTreeImages: "रूखको तस्वीरहरू अपलोड गर्नुहोस्",

    valueAtTheCoordinatesOfInterest: "सम्बन्धित संयोजनको मान",
    "Slope (%)": "कोणात्मकता (%)",
    "Soil texture (USDA class)": "माटोको संरचना (USDA वर्ग)",
    "Coarse fragments (vol%)": "कोर्स भागहरू (वॉल%)",
    Land: "जमिन",
    "Artificial surfaces (type)": "कृत्रिम सतहहरू (प्रकार)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "प्रकार १ र २ सडकहरूसँगको निकटता (मीटर)",
    "Soil Chemical Properties": "माटो रासायनिक गुणस्तर",
    "Soil Physical Properties": "माटो भौतिक गुणस्तर",
    "Soil organic carbon (%)": "माटो जैविक कार्बन (%)",
    "Soil pH": "माटो pH",
    "Soil salinity (ECe))": "माटो लुङ्गियता (ECe))",
    "Mean annual temperature (°C)": "औसत वार्षिक तापमान (°C)",
    Weather: "मौसम",
    "Mean minimum temperature of coldest month (°C)":
      "सबैभन्दा ठुलो महिनाको औसतन न्यून तापमान (°C)",
    "Mean annual precipitation (mm)": "औसत वार्षिक वर्षापात (मिमी)",
  },

  deforestation: {
    eudrComplianceStatus: "EUDR अनुपालन स्थिति",
    deforestationComplianceReport: "वन विनाश अनुपालन रिपोर्ट",
    noDeforestationComplianceReport: "कुनै वन विनाश अनुपालन रिपोर्ट फेला परेन",
    loadingDeforestationComplianceReport: "वन विनाश अनुपालन रिपोर्ट लोड हुँदैछ",
    farmName: "फार्मको नाम",
    farmRegistrationId: "फार्म दर्ता आईडी",
    farmerName: "किसानको नाम",
    farmerRegistrationId: "किसान दर्ता आईडी",
    uniqueFarmerId: "अद्वितीय किसान आईडी",
    uniqueFarmId: "अद्वितीय फार्म आईडी",
    farmLocation: "फार्मको स्थान",
    area: "क्षेत्रफल",
    farmAddress: "फार्मको ठेगाना",
    dateOfRequest: "अनुरोधको मिति",
    status: "स्थिति",
    settings: "सेटिङ",

    farmLatitude: "फार्म अक्षांश",
    farmLongitude: "फार्म देशान्तर",
    shareQRCode: "क्यूआर कोड साझा गर्नुहोस्",
    copy: "कपी गर्नुहोस्",

    allCountries: "सबै देशहरू",
    allRegions: "सबै क्षेत्रहरू",
    allFarms: "सबै फार्महरू",
    viewCertificate: "प्रमाणपत्र हेर्नुहोस्",

    assignmentIssued: "नियुक्ति जारी गरियो",

    complianceCertification: "अनुपालन प्रमाणपत्र",
    noComplianceCertification: "कुनै अनुपालन प्रमाणपत्र फेला परेन",
    loadingComplianceCertification: "अनुपालन प्रमाणपत्र लोड हुँदैछ",

    eudrForestAssessment: "EUDR वन मूल्यांकन",
    assessmentReport: "मूल्यांकन रिपोर्ट",
    downloadPDF: "पीडीएफ डाउनलोड गर्नुहोस्",
    back: "फर्कनुहोस्",
    farmDetails: "फार्म विवरण",

    dimitraFarmId: "दिमित्रा फार्म आईडी",
    dimitraFermerId: "दिमित्रा किसान आईडी",

    totalGeofenceAreaHA: "कुल भू-फेन्स क्षेत्रफल (हेक्टेयर)",
    forestLossHA: "वन क्षति (हेक्टेयर)",
    forestGainHA: "वन वृद्धि (हेक्टेयर)",
    forestUnchangedHA: "वन अपरिवर्तित (हेक्टेयर)",
    shareCertificate: "प्रमाणपत्र साझा गर्नुहोस्",
    forestUnchanged: "वन अपरिवर्तित",
    forestLoss: "वन क्षति",
    forestGain: "वन वृद्धि",
    totalGeofenceArea: "कुल भू-फेन्स क्षेत्रफल",
    print: "प्रिन्ट गर्नुहोस्",
    deforestationProbability: "वन विनाशको सम्भावना",
    colorCode: "रङ्ग कोड",
    geofenceArea: "भू-फेन्स क्षेत्रफल",
    percentageOfGeofenceArea: "भू-फेन्स क्षेत्रफलको प्रतिशत",
    view: "हेर्नुहोस्",
    customization: "अनुकूलन",
    recordsPerpage: "प्रति पृष्ठ रेकर्डहरू",
    restoreDefault: "डिफल्ट पुनःस्थापित गर्नुहोस्",
    apply: "लागू गर्नुहोस्",
    forestAssessmentHelp:
      "यदि तपाईंलाई यस रिपोर्टको बारेमा प्रश्नहरू छन् वा यसलाई बुझ्न मद्दत चाहिन्छ भने, कृपया हेल्प डेस्क मार्फत हामीलाई सम्पर्क गर्नुहोस्।",
    overallDeforestationProbability: "समग्र वन विनाशको सम्भावना",
    zeroOrNegligible: "शून्य/नगण्य",
    high: "उच्च",
    allStatus: "सबै स्थिति",
    low: "न्यून",
    veryHigh: "अत्यन्त उच्च",
    medium: "मध्यम",
    veryLow: "अत्यन्त न्यून",
    assessmentIssued: "मूल्यांकन जारी गरियो",
    certificateIssued: "प्रमाणपत्र जारी गरियो",
    assessmentNo: "मूल्यांकन संख्या",
    blockchainCertificateDesc:
      "प्रमाणपत्र स्वीकृतिपछि ब्लकचेन प्रमाणपत्र मान्यता ह्यास उपलब्ध हुनेछ",
    blockchainValidation: "ब्लकचेन प्रमाणपत्र मान्यता",
    openBlockchainPage: "ब्लकचेन पृष्ठ खोल्नुहोस्",
    clickLinkDesc:
      "ब्लकचेनमा प्रमाणपत्र मान्य गर्न माथि रहेको लिंकमा क्लिक गर्नुहोस्",
    tooltip: {
      dimitraFarmId:
        "दिमित्रा प्रणालीमा विशिष्ट फार्मसँग सम्बन्धित अद्वितीय पहिचानकर्ता।",
      farmName: "फार्मको निर्दिष्ट नाम।",
      farmRegistrationId: "फार्मको दर्ता संख्या।",
      farmLocation: "फार्मको विशिष्ट भौगोलिक स्थान वा स्थान।",
      dimitraFermerId:
        "दिमित्रा प्रणालीमा एक व्यक्तिगत किसानसँग सम्बन्धित अद्वितीय पहिचानकर्ता।",
      farmerName: "फार्मका लागि जिम्मेवार व्यक्तिको पहिचान।",
      farmerRegistrationId: "किसानको दर्ता संख्या।",
      assessmentNo: "मूल्यांकनलाई असाइन गरिएको अद्वितीय संख्या।",
    },
    red: "रातो",
    Yellow: "पहेंलो",
    transparent: "पारदर्शी",
    darkRed: "गाढा रातो",
    brightRed: "उज्ज्वल रातो",
    orange: "सुन्तला",
    lightBlue: "लाइट ब्लु",
    teal: "तेल",
    zeroOrNegligibleProbability: "शून्य/नगण्य वन विनाशको सम्भावना",
    riskDetected: "जोखिम पत्ता लागेको छ",
    zeroOrNegligibleRisk: "शून्य/नगण्य जोखिम",
        manuallyMitigated: "म्यानुअल रूपमा न्यून गरिएको",
    compliant: "अनुपालन",
    nonCompliant: "गैर-अनुपालन",
    veryLowProbability: "अत्यन्त न्यून वन विनाशको सम्भावना",
    lowProbability: "न्यून वन विनाशको सम्भावना",
    mediumProbability: "मध्यम वन विनाशको सम्भावना",
    highProbability: "उच्च वन विनाशको सम्भावना",
    veryHighProbability: "अत्यन्त उच्च वन विनाशको सम्भावना",
    locationName: "स्थानको नाम",
  },
  farm: {
    activities: "कृषि गतिविधिहरू",
    "search": "खोज्नुहोस्",
    "selectCountry": "देश छान्नुहोस्",
    "filterByFarmName": "फार्मको नाम अनुसार फिल्टर गर्नुहोस्",
    "filterByCropType": "फसलको प्रकार अनुसार फिल्टर गर्नुहोस्",
    "filterByStartDate": "सुरु मिति अनुसार फिल्टर गर्नुहोस्",
    "download": "डाउनलोड गर्नुहोस्",
    "of": "को",
    "previousPage": "अघिल्लो पृष्ठ",
    "nextPage": "अर्को पृष्ठ",
    "view": "हेर्नुहोस्",
    "activityDetails": "गतिविधि विवरण",
    "activity": "गतिविधि",
    "cropType": "फसलको प्रकार",
    "startDate": "सुरु मिति",
    "endDate": "समाप्ति मिति",
    "description": "विवरण",
    "close": "बन्द गर्नुहोस्",
    "farmName": "फार्मको नाम",
    "farmLocation": "फार्मको स्थान",
    "farmSize": "फार्मको आकार",
    "farmAddress": "फार्मको ठेगाना",
    "farmOwner": "फार्मको मालिक",
    "farmType": "फार्मको प्रकार",
    "farmRegistrationId": "फार्म दर्ता आईडी",
    "farmLatitude": "फार्म अक्षांश",
    "farmLongitude": "फार्म देशान्तर",
    "farmArea": "फार्मको क्षेत्र",
    "farmSizeUnit": "फार्मको आकार इकाई",
    "farmOwnerName": "फार्म मालिकको नाम",
    "farmOwnerPhone": "फार्म मालिकको फोन",
    "farmOwnerEmail": "फार्म मालिकको इमेल",
    "farmOwnerAddress": "फार्म मालिकको ठेगाना",
    "farmOwnerCountry": "फार्म मालिकको देश",
    "farmOwnerCity": "फार्म मालिकको शहर",
    "farmActivities": "फार्म गतिविधिहरू",  
    "listView": "सूची हेर्नुहोस्",
    "calendarView": "पात्रो हेर्नुहोस्",
    "scheduledActivities": "अनुसूचित गतिविधिहरू",
    "completedActivities": "समाप्त गतिविधिहरू",
  },
  pleaseAgreeToDeclaration: "समाप्त गर्न कृपया घोषणासँग सहमत हुनुहोस्।",
  importProductionPlaceTT: "प्रयोगकर्ताहरूलाई फाइल अपलोड वा डाउनलोड विकल्पहरू प्रयोग गरेर उत्पादन स्थान डेटा आयात गर्न अनुमति दिन्छ।",
  defaultCircularGeofence: "जियोफेन्स नभएका वा तिनीहरूको आकारको बारेमा जानकारी नभएका फार्महरूलाई ४ हेक्टरको डिफल्ट सर्कुलर जियोफेन्स दिइनेछ। यदि औसत फार्म आकार ४ हेक्टर भन्दा सानो छ भने, कृपया तलको 'सम्पादन' बटन क्लिक गरेर डिफल्ट आकार परिवर्तन गर्नुहोस्।",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "EUDR अनुसार, ४ हेक्टर भन्दा कम क्षेत्रफल भएका फार्महरूलाई बहुभुज आवश्यक पर्दैन।",
  uploadOneDeforestationAssessmentForAllFarms: "सबै फार्महरूको लागि एक वनमुक्ति मूल्याङ्कन अपलोड गर्नुहोस्",
  uploadAssessment: "मूल्याङ्कन अपलोड गर्नुहोस्",
  noUploadToBlockchain: "ब्लकचेनमा अपलोड गरिएको छैन",
  noDataForBlockchain: "उत्पादन स्थलहरूको लागि वनमुक्ति रिपोर्टहरू उत्पन्न नभएकोले, ब्लकचेनमा लेख्नको लागि कुनै डेटा थिएन। यदि यो अप्रत्याशित थियो भने, कृपया सुनिश्चित गर्नुहोस् कि फार्महरूको लागि रिपोर्टहरू अघिल्लो चरणहरूमा सही रूपमा उत्पन्न गरिएको थियो।"
};
